import { ElementRef } from '@angular/core';

export function style<T extends HTMLElement>(
  elementRef: ElementRef<T>,
  twClasses: string
): void {
  twClasses
    .split(' ')
    .forEach((twClass) => elementRef.nativeElement.classList.add(twClass));
}

export function updateElementStyles<T extends HTMLElement>(
  elementRef: ElementRef<T>,
  twClasses: string
): void {
  elementRef.nativeElement.className = twClasses;
}
